import { useRentalManagerUserPropertyListWebApiHandler_list } from '@zg-rentals/ts-rental-manager-api-client-react-query';

export const PROPERTIES_QUERY_TAG = 'properties';

export interface PropertyListing {
  listingAlias: string;
  fullAddress: string;
  propertyTypeCode: number;
  unitNumber?: string;
}

export interface GetPropertiesResponse {
  listings: Array<PropertyListing>;
}

export function useGetProperties(options?: { enabled?: boolean }) {
  return useRentalManagerUserPropertyListWebApiHandler_list(
    {},
    {
      enabled: options?.enabled !== false,
      meta: { tags: [PROPERTIES_QUERY_TAG] },
    },
  );
}
